const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getBabaPackets(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.programId) params.append('programId', filters.programId);
  if (filters.siteId) params.append('siteId', filters.siteId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/baba/packets${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view BABA packets');
    }
    throw new Error('Failed to fetch BABA packets');
  }
  
  const data = await response.json();
  return data.packets;
}

export async function getBabaPacket(orgId, packetId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/baba/packets/${packetId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Packet not found');
    }
    throw new Error('Failed to fetch packet');
  }
  
  const data = await response.json();
  return data.packet;
}

export async function getPacketStatus(orgId, packetId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/baba/packets/${packetId}/status`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch packet status');
  }
  
  return response.json();
}

export async function createBabaPacket(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/baba/packets`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to generate BABA packets');
    }
    throw new Error('Failed to generate packet');
  }
  
  const result = await response.json();
  return result.packet;
}

export async function downloadPacket(orgId, packetId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/baba/packets/${packetId}/download`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({})
  });
  
  if (!response.ok) {
    throw new Error('Failed to download packet');
  }
  
  return response.json();
}
